/**
 * Account deletion job values that must stay aligned with server
 * `accountDeletion.service.js` (DELETION_ERROR_CODES / lastErrorCode).
 */

/** FAILED jobs with these codes: Postgres data may be gone but Supabase auth user can still exist. */
export const ACCOUNT_DELETION_INCOMPLETE_LAST_ERROR_CODES = {
  SUPABASE_DELETE_FAILED: 'SUPABASE_DELETE_FAILED',
  SUPABASE_ADMIN_MISSING: 'SUPABASE_ADMIN_MISSING',
} as const

export function isIncompleteDeletionLastErrorCode(code: string): boolean {
  return (
    code === ACCOUNT_DELETION_INCOMPLETE_LAST_ERROR_CODES.SUPABASE_DELETE_FAILED ||
    code === ACCOUNT_DELETION_INCOMPLETE_LAST_ERROR_CODES.SUPABASE_ADMIN_MISSING
  )
}
